import WindowedSelect, { Props } from "react-windowed-select";

const customReactSelectStyles = {
  control: (styles: any, { isDisabled, isFocused }: any) => ({
    ...styles,
    height: "30px",
    width: "100%",
    borderRadius: "4px",
    borderColor: isFocused ? "#3182ce" : "inherit",
    background: isDisabled ? "white" : "",
    color: isDisabled ? "gray" : "",
  }),
  menu: (styles: any) => ({
    ...styles,
    marginTop: 0,
    borderRadius: "none",
  }),
  placeholder: (styles: any) => ({
    ...styles,
    color: "#718096",
  }),
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
};

export default function VirtualizedSelect(props: Props) {
  return <WindowedSelect windowThreshold={100} {...props} styles={customReactSelectStyles} />;
}
